import { createSelector } from 'reselect'

import { selectPartner360Data } from './selectPartner360Data'

export const selectPartnerHeaderKey = createSelector(
  [selectPartner360Data],
  ({ partnerHeaderKey }) => partnerHeaderKey
)
